import { Route } from '@angular/compiler/src/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PackageType } from 'src/app/_models/package_type';
import { MessService } from 'src/app/_services/mess-service.service';
import { PackageTypesService } from 'src/app/_services/package-types.service';

@Component({
  selector: 'app-package-types-edit',
  templateUrl: './package-types-edit.component.html',
})
export class PackageTypesEditComponent implements OnInit, OnDestroy {
  updatePackageTypeForm: FormGroup;

  packageForEdit: PackageType;
  packageForEditSub: Subscription;

  constructor(
    private packageTypesService: PackageTypesService,
    private fb: FormBuilder,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updatePackageTypeForm = this.fb.group({
      label: [''],
      name: [''],
    });

    this.packageForEditSub =
      this.packageTypesService.updatePackageTypeData.subscribe(
        (packageType: PackageType) => {
          if (!packageType) {
            this.router.navigate(['./../'], { relativeTo: this.route });
            return;
          }
          this.packageForEdit = packageType;
          this.patchFormForUpdate();
        }
      );
  }

  ngOnDestroy() {
    this.packageForEditSub.unsubscribe();
    this.messService.clearErrors();
  }

  // * Update === //
  onUpdatePackageType() {
    const packageType = this.updatePackageTypeForm.getRawValue();
    this.packageTypesService
      .updatePackageType(this.packageForEdit.id, packageType)
      .subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno ažuriranje',
            detail: 'Ažurirali ste tip pakovanja.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.updatePackageTypeForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      );
  }

  // * Helpers === //
  getControls() {
    return (<FormGroup>this.updatePackageTypeForm).controls;
  }

  private patchFormForUpdate() {
    this.updatePackageTypeForm.patchValue({
      label: this.packageForEdit.label,
      name: this.packageForEdit.name,
    });
  }
}
